<div mat-dialog-title class="aa-editor__header">
    <span class="aa-editor__title" autoTranslate>{{ isExisting ? 'Editar Turno' : 'Iniciar Turno' }}</span>
    <button
        mat-icon-button
        type="button"
        class="aa-editor__close"
        (click)="cancel()"
        [attr.aria-label]="'Fechar' | autoTranslate"
    >
        <mat-icon class="text-secondary" svgIcon="heroicons_outline:x-mark"></mat-icon>
    </button>
</div>

<mat-dialog-content class="aa-editor">
    <ng-container *ngIf="isExisting && data.existing as ex">
        <div class="aa-editor__badges">
            <span class="aa-editor__badge aa-editor__badge--person">{{ ex.label }}</span>
            <span class="aa-editor__badge aa-editor__badge--duration" *ngIf="durationLabel">{{ durationLabel }}</span>
        </div>
        <p class="aa-editor__meta" *ngIf="(data.crew?.length || 0) > 1">
            <span autoTranslate>Equipe</span>: {{ crewNames }}
        </p>

        <section class="aa-editor__section">
            <span class="aa-editor__label" autoTranslate>Início do turno</span>
            <mat-form-field class="aa-editor__field w-full" [subscriptSizing]="'dynamic'">
                <input matInput type="datetime-local" [(ngModel)]="startedAtLocal" />
            </mat-form-field>
        </section>

        <section class="aa-editor__section" *ngIf="isClosed">
            <span class="aa-editor__label" autoTranslate>Fim do turno</span>
            <mat-form-field class="aa-editor__field w-full" [subscriptSizing]="'dynamic'">
                <input matInput type="datetime-local" [(ngModel)]="endedAtLocal" />
            </mat-form-field>
            <button
                *ngIf="suggestedEndLabel"
                mat-button
                color="primary"
                type="button"
                class="aa-editor__suggest"
                (click)="suggestPlannedEnd()"
                [matTooltip]="'Usar o horário da Escala' | autoTranslate"
            >
                <mat-icon svgIcon="heroicons_outline:clock" class="icon-size-4"></mat-icon>
                <span autoTranslate>Usar horário da Escala</span>&nbsp;({{ suggestedEndLabel }})
            </button>
        </section>
    </ng-container>

    <ng-container *ngIf="!isExisting">
        <section class="aa-editor__section" *ngIf="isCrewStart">
            <span class="aa-editor__label" autoTranslate>Profissionais</span>
            <div class="aa-editor__badges">
                <span
                    class="aa-editor__badge aa-editor__badge--person aa-editor__badge--initials"
                    *ngFor="let u of data.presetUsers"
                    [matTooltip]="u.name"
                >
                    {{ initialsFrom(u.name) }}
                </span>
            </div>
        </section>

        <section class="aa-editor__section" *ngIf="!isCrewStart">
            <span class="aa-editor__label" autoTranslate>Profissional</span>
            <mat-form-field class="aa-editor__field w-full" [subscriptSizing]="'dynamic'">
                <mat-select [(ngModel)]="selectedUserId">
                    <mat-option *ngFor="let u of filteredUsers" [value]="u.user_id">
                        {{ u.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </section>

        <section class="aa-editor__section">
            <span class="aa-editor__label" autoTranslate>Início do turno</span>
            <mat-form-field class="aa-editor__field w-full" [subscriptSizing]="'dynamic'">
                <input matInput type="datetime-local" [(ngModel)]="startedAtLocal" />
            </mat-form-field>
            <button
                *ngIf="plannedStartLabel"
                mat-button
                color="primary"
                type="button"
                class="aa-editor__suggest"
                (click)="suggestPlannedStart()"
                [matTooltip]="'Usar o horário da Escala' | autoTranslate"
            >
                <mat-icon svgIcon="heroicons_outline:clock" class="icon-size-4"></mat-icon>
                <span autoTranslate>Usar horário da Escala</span>&nbsp;({{ plannedStartLabel }})
            </button>
        </section>
    </ng-container>
</mat-dialog-content>

<mat-dialog-actions class="aa-editor__actions">
    <div class="aa-editor__actions-row" *ngIf="isExisting && data.existing?.isOpen">
        <button mat-stroked-button type="button" class="aa-editor__action" (click)="addPerson()" autoTranslate>
            Adicionar outro
        </button>
        <button
            mat-flat-button
            color="warn"
            type="button"
            class="aa-editor__action"
            (click)="closeAllocation()"
            autoTranslate
        >
            Fechar turno
        </button>
    </div>
    <button
        *ngIf="isExisting"
        mat-flat-button
        color="primary"
        type="button"
        class="aa-editor__save"
        (click)="saveSchedule()"
        [disabled]="!hasScheduleChanges"
        autoTranslate
    >
        Salvar
    </button>
    <button
        *ngIf="!isExisting"
        mat-flat-button
        color="primary"
        type="button"
        class="aa-editor__save"
        (click)="save()"
        [disabled]="!canSaveStart"
        autoTranslate
    >
        Salvar
    </button>
    <button
        *ngIf="isExisting"
        mat-button
        color="warn"
        type="button"
        class="aa-editor__remove"
        (click)="remove()"
        autoTranslate
    >
        Remover
    </button>
</mat-dialog-actions>
